function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDistributedMammalGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.843751",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-277.15624)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-8-1-0-1",
    width: 19.84375,
    height: 19.84375,
    x: -1.7763568e-15,
    y: 277.15625
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#925214",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834876,
      strokeOpacity: 1
    },
    id: "rect4518-8-4-5-38-2-5-4",
    width: 17.197918,
    height: 17.197918,
    x: 1.3229218,
    y: 278.47919
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: "0.02908051px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 11.69933,281.2586 c -0.707791,0.0191 -0.808119,0.19455 -1.8576015,0.76494 -0.441225,0.26307 -0.8172688,0.53259 -1.017269,0.60719 -0.9232281,0.40287 -1.695118,0.41012 -1.695118,0.41012 0,0 -0.2254739,-1.39921 -0.936526,-1.37522 v 0 c -0.711049,0.0241 -0.3573651,1.74965 -0.3573651,1.74965 0,0 -1.361005,0.69797 -1.8546109,1.15025 -0.4936091,0.45225 -1.2081222,0.67379 -1.2026821,1.05298 0.0054,0.37922 0.019219,0.92482 0.372817,1.01162 0.3535971,0.0868 0.351882,0.057 0.351882,0.057 0,0 0.0076,0.42402 0.5507509,0.3941 0.543156,-0.0299 1.2777902,-0.14609 1.7474521,0.0254 0.469661,0.17145 1.0294331,0.47436 1.0526572,0.65527 0.02323,0.18088 -0.282884,0.74473 -0.3633462,0.80992 -0.08047,0.0652 -0.3675499,-0.35928 -0.916091,0.11119 -0.548541,0.47092 -0.436082,0.7871 -0.1973731,0.7871 h 2.2677991 c 0,0 0.250117,-0.20138 0.305031,-0.49287 0.05492,-0.29147 0.4625311,-0.78459 0.4625311,-0.78459 0,0 0.813225,0.20734 1.358686,-0.0507 0,0 -0.464702,-1.14913 -0.2063448,-1.9922 0.2583579,-0.84306 0.3950578,-0.84483 0.6643903,-1.06646 0.269332,-0.22162 1.074158,-0.55366 1.365663,-0.51563 0.348666,0.0454 0.08358,0.31861 -0.153512,0.31861 -0.237093,0 -1.115583,0.36389 -1.310838,1.01575 -0.1952515,0.65184 -0.2091434,1.48546 0.08373,2.06151 0.202797,0.39887 0.425369,0.55746 0.543275,0.61754 -0.153659,-0.0576 -0.481245,-0.15882 -0.668876,-0.057 -0.2510384,0.13646 -0.7709423,0.60233 -0.6035825,0.76907 0.167359,0.16675 0.012869,0.17689 0.5019061,0.17689 h 3.1838894 c 0,0 0.446509,-0.14214 0.334936,-0.68787 l 0.725197,-0.59165 c 0.355414,-0.33948 0.587845,-0.8005 0.739652,-1.23919 0.26936,0.15289 0.482163,0.30888 0.55723,0.39047 0.139468,0.15157 0.948299,0.84917 -0.111644,2.56217 -1.059945,1.71297 -4.672038,2.319 -5.24385,2.42511 -0.5718105,0.1061 -1.7433644,-0.0909 -1.5899505,0.33357 0.1534131,0.42445 2.1058845,0.19722 3.7515865,-0.0605 1.645704,-0.25771 3.682209,-1.50066 4.29586,-2.54665 0.613653,-1.04597 0.487752,-1.98593 0.180925,-3.01675 -0.226565,-0.7612 -1.105405,-1.26501 -1.550576,-1.47712 0.04539,-0.23601 0.192146,-1.2398 -0.331946,-2.31285 -0.599706,-1.22792 -1.952416,-1.94002 -2.90079,-1.98551 -0.118546,-0.006 -0.226845,-0.007 -0.327958,-0.005 z m -6.3079695,3.30539 c 0.2692109,-0.0148 0.4998929,0.21009 0.5148649,0.5027 0.01497,0.29263 -0.191335,0.54218 -0.460538,0.55701 -0.269203,0.0148 -0.4993849,-0.21062 -0.5143659,-0.50323 -0.014981,-0.2926 0.1908278,-0.54165 0.460039,-0.55648 z",
    id: "path20878-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDistributedMammalGrid);
export default __webpack_public_path__ + "static/media/icon-distributed-mammal-grid.a08b955e48becc3782ab051b5ba55db5.svg";
export { ForwardRef as ReactComponent };